import { Label, Layout, LayoutHeader, Panel } from "@mcleod/components";

export abstract class AutogenLayoutDemoScreenFlowSample extends Layout {
    labelPurpose: Label;
    layoutSampleButtons: Layout;
    layoutheaderScreenFlowSample: LayoutHeader;
    panelPurpose: Panel;
}
